export function isAssignedToDriver(item, driverId) {
  return driverId != null
    && item?.driver_id != null
    && String(item.driver_id) === String(driverId);
}
